<template>
  <div class="grade">
    <div class="hd ly-card">
      <div class="fl">
        <el-button class="fl" size="medium" @click="openDigFrom(true)" type="primary">新增</el-button>
        <advanced-query @search="search" />
      </div>
      <div class="fr">
        <el-input
          v-model.trim="searchFormData.name"
          placeholder="项目级别名"
          @keypress.enter.native="() => search()"
        ></el-input>
        <el-button @click="() => search()" class="m-r-15">查询</el-button>
        <el-button @click="exportExcel" type="primary">导出</el-button>
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      :statusAction="statusAction"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:use="row">
        <el-button @click="showRow(row)" type="text" size="mini">查看</el-button>
      </template>
      <template v-slot:action="row">
        <el-button @click="editRow(row)" type="primary" size="mini">修改</el-button>
        <el-button @click="delRow(row)" type="danger" size="mini">删除</el-button>
      </template>
    </ly-table>
    <el-dialog
      :title="`${defaultFormItem.id ? '修改' : '新增'}项目级别`"
      :visible.sync="dialogVisible"
      @opened="openEvent"
      width="500px"
    >
      <ly-form
        :defaultFormItem="defaultFormItem"
        :formConfig="formConfig"
        :formKeys="formKeys"
        class="grade-form"
        ref="lyForm"
      ></ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGrade">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog, Input } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { gradeTable } from '@/utils/tableHeader';
import { gradeFormItem } from '@/utils/formConfig';
import { base } from '@/api';
import AdvancedQuery from '@/components/AdvancedQuery';
import utils from '@/utils/utils';

export default {
  name: 'grade',
  components: {
    LyTable,
    LyForm,
    ElDialog: Dialog,
    ElInput: Input,
    AdvancedQuery
  },
  data() {
    return {
      dialogVisible: false,
      formKeys: gradeFormItem,
      defaultFormItem: {},
      formConfig: {
        'label-width': '140px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      searchFormData: {
        name: ''
      },
      tableHeader: gradeTable,
      getTableData: base.getGrade,
      statusAction: [row => base.activateGrade({ id: row.id }), row => base.deactivateGrade({ id: row.id })]
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    openDigFrom(isAdd) {
      this.dialogVisible = true;
      if (isAdd) {
        this.defaultFormItem = {
          activate_status: true
        };
      }
    },
    openEvent() {
      this.$refs.lyForm.$refs.lyForm.clearValidate();
    },
    async addGrade() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (this.defaultFormItem.id) {
          // 修改
          res = await base.controlGrade({
            methold: 'put',
            id: this.defaultFormItem.id,
            params: data
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        } else {
          // 新增
          res = await base.grade({ params: data, methold: 'post' });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        }
        if (res) {
          this.$refs.lyTable.setData();
          this.$refs.lyForm.resetFields();
          this.dialogVisible = false;
        }
      }
    },
    delRow(row) {
      this.$confirm('确认删除？')
        .then(() => {
          base
            .controlGrade({
              methold: 'delete',
              id: row.id
            })
            .then(res => {
              this.search();
              this.$store.dispatch('msg/showMsg', res.msg || '删除成功');
            });
        })
        .catch(() => {});
    },
    editRow(row) {
      this.defaultFormItem = { ...row };
      this.openDigFrom();
    },
    addRow() {},
    async search(data) {
      this.searchFormData = {
        ...this.searchFormData,
        ...data
      };
      this.$refs.lyTable.setData();
    },
    exportExcel() {
      base.exportFeeLevel({ params: this.searchFormData }).then(data => {
        if (data) utils.downloadData(data, '级别列表');
      });
    }
  }
};
</script>

<style lang="less">
.grade {
  .hd {
    overflow: hidden;
    .el-input {
      width: 200px;
      margin-right: 20px;
    }
    .ly-search-comp {
      display: inline-block;
      margin: auto 5px;
    }
  }
  .grade-form {
    .el-input {
      width: 220px;
    }
  }
}
</style>
